var React = require('react');

function AfterpayMoonRedNavyInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"188","cy":"188","r":"188","fill":"url(#moon_red_navy_paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"moon_red_navy_paint0_linear","x1":"188","y1":"0","x2":"188","y2":"188","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#FF5A7D","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#143673","key":1})]))]);
}

AfterpayMoonRedNavyInline.defaultProps = {"width":"376","height":"376","viewBox":"0 0 376 376","fill":"none"};

module.exports = AfterpayMoonRedNavyInline;

AfterpayMoonRedNavyInline.default = AfterpayMoonRedNavyInline;
